import { COLUMN, Table } from "Areas/SharedFeatures/rightSideDetailsPanel";
import { GRAPH_GROUP_NODE_LABEL_TABLE_CLASS_NAME } from "Common/componentUtils/constants";
import classNames from "classnames";
import map from "lodash/map";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { NODE_GROUP_MIN_SIZE } from "../constants";
const SIZES = {
    HEADER_HEIGHT: 30
};
const groupTableColumns = [COLUMN.ID, COLUMN.COLOR, COLUMN.PIN_ACTION];
export default function GroupNodeLabel(props) {
    var _a, _b, _c;
    const [data, setData] = useState(() => { var _a; return map((_a = props.tag) === null || _a === void 0 ? void 0 : _a.Nodes, e => ({ ...e, Id: e.NodeId })); });
    const gridRef = useRef(null);
    const wrapperStyle = useMemo(() => {
        var _a, _b;
        return ({
            height: Math.max(NODE_GROUP_MIN_SIZE.height, ((_a = props.tag) === null || _a === void 0 ? void 0 : _a.NodeHeight) || 0) - 4,
            width: Math.max(NODE_GROUP_MIN_SIZE.width, ((_b = props.tag) === null || _b === void 0 ? void 0 : _b.NodeWidth) || 0) - 2,
            paddingTop: SIZES.HEADER_HEIGHT
        });
    }, [(_a = props.tag) === null || _a === void 0 ? void 0 : _a.NodeHeight, (_b = props.tag) === null || _b === void 0 ? void 0 : _b.NodeWidth, data.length]);
    useEffect(() => {
        if (props.groupRef) {
            props.groupRef.current = {
                setData: (nodeSources) => {
                    setData(nodeSources ? [...nodeSources] : []);
                },
                grid: gridRef
            };
        }
    }, []);
    useEffect(() => {
        var _a;
        setData(map((_a = props.tag) === null || _a === void 0 ? void 0 : _a.Nodes, e => ({ ...e, Id: e.NodeId })));
    }, [(_c = props.tag) === null || _c === void 0 ? void 0 : _c.Nodes]);
    if (!(data === null || data === void 0 ? void 0 : data.length) || !props.wrapperId)
        return null;
    return (React.createElement("div", { style: wrapperStyle, className: classNames("overflow-hidden", props.className) },
        React.createElement(Table, { data: data, gridRef: gridRef, onContentReady: props.onContentReady, documentObjects: props.documentObjects, wrapperHeight: wrapperStyle.height - wrapperStyle.paddingTop, className: classNames("h-100-max", GRAPH_GROUP_NODE_LABEL_TABLE_CLASS_NAME), columns: groupTableColumns, showFilter: false, showTotal: false, wrapperWidth: wrapperStyle.width, onRowsPin: props.onRowsPin, onTableEventStopPropagation: props.onTableEventStopPropagation, allowColumnResizing: false, isExporting: props.isExporting, showBorders: false, isRightSideDetailsPanel: false })));
}
